/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ec33x5SEN4aEEFQbKCmZsX
// Component: Ol7Sy0qUOFXf
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import TopNavOld from "../../TopNavOld"; // plasmic-import: lsUGdJlDUbSW/component
import ButtonPageOld from "../../ButtonPageOld"; // plasmic-import: gPXXnR2LihsE/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectcss
import sty from "./PlasmicSectionHero.module.css"; // plasmic-import: Ol7Sy0qUOFXf/css

createPlasmicElementProxy;

export const PlasmicSectionHero__VariantProps = new Array("colWidth");

export const PlasmicSectionHero__ArgProps = new Array(
  "sectionId",
  "showTagline",
  "navbar",
  "children",
  "slot"
);

const $$ = {};

function PlasmicSectionHero__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          showTagline: true
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "colWidth",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.colWidth
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <section
      data-plasmic-name={"hero"}
      data-plasmic-override={overrides.hero}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ec33x5SEN4aEEFQbKCmZsX",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.hero
      )}
      id={(() => {
        try {
          return $props.sectionId;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <TopNavOld
            className={classNames("__wab_instance", sty.topNavOld__vmMn7)}
            pageButtons={
              <React.Fragment>
                <ButtonPageOld
                  content={"overview"}
                  isSelected={true}
                  textColor={"secondary"}
                />

                <ButtonPageOld
                  className={classNames(
                    "__wab_instance",
                    sty.buttonPageOld__wqnvA
                  )}
                  content={"the OP cause"}
                  textColor={"secondary"}
                />

                <ButtonPageOld
                  className={classNames(
                    "__wab_instance",
                    sty.buttonPageOld__s7Qa
                  )}
                  content={"contact"}
                  textColor={"secondary"}
                />

                <ButtonPageOld content={"sign up free"} textColor={"brand"} />
              </React.Fragment>
            }
          />
        ),

        value: args.navbar
      })}
      <div
        data-plasmic-name={"contentHero"}
        data-plasmic-override={overrides.contentHero}
        className={classNames("all", sty.contentHero, {
          [sty.contentHerocolWidth_full]: hasVariant($state, "colWidth", "full")
        })}
      >
        <div
          className={classNames("all", sty.freeBox__bsoD3, {
            [sty.freeBoxcolWidth_full__bsoD3IPxXg]: hasVariant(
              $state,
              "colWidth",
              "full"
            ),
            [sty.freeBoxcolWidth_medium__bsoD3Z7Bm]: hasVariant(
              $state,
              "colWidth",
              "medium"
            ),
            [sty.freeBoxcolWidth_small__bsoD38YIva]: hasVariant(
              $state,
              "colWidth",
              "small"
            )
          })}
        >
          <div
            className={classNames("all", sty.freeBox___6Ujbz, {
              [sty.freeBoxcolWidth_full___6UjbziPxXg]: hasVariant(
                $state,
                "colWidth",
                "full"
              ),
              [sty.freeBoxcolWidth_medium___6Ujbzz7Bm]: hasVariant(
                $state,
                "colWidth",
                "medium"
              ),
              [sty.freeBoxcolWidth_small___6Ujbz8YIva]: hasVariant(
                $state,
                "colWidth",
                "small"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: (
                <div
                  className={classNames("all", "__wab_text", sty.text__duvtl)}
                >
                  {"Enter some text"}
                </div>
              ),

              value: args.children
            })}
          </div>
          {(() => {
            try {
              return $props.showTagline;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return true;
              }
              throw e;
            }
          })() ? (
            <div
              className={classNames("all", sty.freeBox__igX6J, {
                [sty.freeBoxcolWidth_full__igX6JiPxXg]: hasVariant(
                  $state,
                  "colWidth",
                  "full"
                ),
                [sty.freeBoxcolWidth_medium__igX6Jz7Bm]: hasVariant(
                  $state,
                  "colWidth",
                  "medium"
                ),
                [sty.freeBoxcolWidth_small__igX6J8YIva]: hasVariant(
                  $state,
                  "colWidth",
                  "small"
                )
              })}
            >
              {renderPlasmicSlot({
                defaultContents: (
                  <div
                    className={classNames("all", "__wab_text", sty.text__se8IH)}
                  >
                    {"Enter some text"}
                  </div>
                ),

                value: args.slot
              })}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}

const PlasmicDescendants = {
  hero: ["hero", "contentHero"],
  contentHero: ["contentHero"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSectionHero__ArgProps,
          internalVariantPropNames: PlasmicSectionHero__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSectionHero__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "hero") {
    func.displayName = "PlasmicSectionHero";
  } else {
    func.displayName = `PlasmicSectionHero.${nodeName}`;
  }
  return func;
}

export const PlasmicSectionHero = Object.assign(
  // Top-level PlasmicSectionHero renders the root element
  makeNodeComponent("hero"),
  {
    // Helper components rendering sub-elements
    contentHero: makeNodeComponent("contentHero"),
    // Metadata about props expected for PlasmicSectionHero
    internalVariantProps: PlasmicSectionHero__VariantProps,
    internalArgProps: PlasmicSectionHero__ArgProps
  }
);

export default PlasmicSectionHero;
/* prettier-ignore-end */
